import * as e from "react";
import c from "../lib/IconBase.es.js";
import t from "../defs/CalendarCheck.es.js";
const a = e.forwardRef((o, r) => /* @__PURE__ */ e.createElement(c, { ref: r, ...o, weights: t }));
a.displayName = "CalendarCheckIcon";
const s = a;
export {
  s as CalendarCheck,
  a as CalendarCheckIcon
};
